// Builds the address-related slice of the cleaning-request create payload from
// the stepperInfo redux state. Keeps city + full formatted address and adds the
// structured fields from the shared CleaningRequest contract. All extra fields
// are nullable/blank-friendly.

const blankToNull = (value) => {
    if (value === undefined || value === null) return null;
    const str = value.toString().trim();
    return str === '' ? null : str;
};

const numOrNull = (value) =>
    value === undefined || value === null || value === '' ? null : Number(value);

// Backend latitude/longitude are DecimalField(decimal_places=6); Google returns
// 7+ decimals, which DRF rejects ("no more than 6 decimal places") and 400s the
// whole order. Round coordinates to 6 dp before sending.
const coordOrNull = (value) => {
    const num = numOrNull(value);
    return num === null || Number.isNaN(num) ? null : Number(num.toFixed(6));
};

// `state` is the stepperInfo slice (or any object exposing the same keys).
export const buildCleaningAddress = (state) => {
    const {
        selectedCity,
        address,
        street,
        buildingNumber,
        apartment,
        entrance,
        floor,
        intercomCode,
        postalCode,
        latitude,
        longitude,
        placeId,
    } = state;

    // Fallback formatted address if Google did not provide one.
    let formattedAddress = (address || '').trim();
    if (!formattedAddress) {
        formattedAddress = `${street || ''}, буд. ${buildingNumber || ''}`.trim();
        if (entrance) formattedAddress += `, під. ${entrance}`;
        if (apartment) formattedAddress += `, кв. ${apartment}`;
    }

    return {
        city: selectedCity || null,
        address: formattedAddress,
        street: blankToNull(street),
        building_number: blankToNull(buildingNumber),
        apartment: blankToNull(apartment),
        entrance: blankToNull(entrance),
        floor: blankToNull(floor),
        intercom_code: blankToNull(intercomCode),
        postal_code: blankToNull(postalCode),
        latitude: coordOrNull(latitude),
        longitude: coordOrNull(longitude),
        place_id: blankToNull(placeId),
    };
};
